var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorexdexx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.1479,
    cy: 27.168,
    r: 26.2249,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8354 15.3619C3.78996 21.2289 8.84287 40.0675 23.462 40.0675H27.2059V37.4436V34.8197L25.6867 35.3914C17.9276 38.3114 10.4705 29.5901 14.7647 22.6185C16.9971 18.9931 22.6494 17.1725 26.0604 18.9797C27.1147 19.5384 27.2059 19.3748 27.2059 16.9274V14.2684L23.2079 14.2813C20.6296 14.2895 18.367 14.6729 16.8354 15.3619ZM33.7271 19.2464L28.7246 24.2245L26.4934 22.0679L24.2622 19.9108L22.7625 21.3057L21.2628 22.7006L23.494 24.9715L25.7252 27.2424L23.4525 29.3116L21.1799 31.3814L22.5285 32.8027L23.8778 34.224L26.1422 32.0352L28.4065 29.8464L33.5927 34.957L38.7795 40.0675H41.719H44.6592L38.032 33.4712L31.4041 26.8748L37.8626 20.5716L44.3216 14.2684H41.5254H38.7297L33.7271 19.2464ZM36.0904 27.0923V29.3621L40.5327 29.3972L44.9749 29.4318V27.1269V24.8226H40.5327H36.0904V27.0923Z",
    fill: "#FF9906"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorexdexx);
export default __webpack_public_path__ + "static/media/corexdexx.9a83038299dbb7a0644a866bb861e04d.svg";
export { ForwardRef as ReactComponent };